import { googleMapKey } from "../constants/Config";
import { Loader } from "@googlemaps/js-api-loader";

import { countryAbbreviations } from "../constants/CountryAbbreviations";

interface Address {
  city: string | null;
  patientState: string | null;
  zipCode: string | null;
  streetName1: string | null;
  streetName2: string | null;
  county: string | null;
  country: string | null;
  streetNumber: string | null;
}

export const initMapScript = () => {
  const loader = new Loader({
    apiKey: googleMapKey,
    version: "weekly",
  });
  return loader.importLibrary("places");
};

export const extractPatientAddress = (place: any) => {
  const address: Address = {
    city: null,
    patientState: null,
    zipCode: null,
    streetName1: null,
    streetName2: null,
    county: null,
    country: null,
    streetNumber: null,
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  let township: string | null = null;

  // Mapping for address component types to Address keys
  const mapTypesToAddress: { [key: string]: keyof Address } = {
    street_number: "streetNumber",
    route: "streetName1",
    neighborhood: "streetName2",
    "administrative_area_level_2": "county",
    "administrative_area_level_1": "patientState",
    postal_code: "zipCode",
    country: "country",
  };

  place.address_components.forEach((component: {
    types: Array<string>;
    long_name: string;
    short_name: string;
  }) => {
    const { types, long_name: value, short_name } = component;

    if (types.includes("locality")) {
      address.city = value;
    }

    if (types.includes("administrative_area_level_3")) {
      township = value;
    }

    types.forEach(type => {
      const addressKey = mapTypesToAddress[type];
      if (addressKey) {
        if (type === "country") {
          address[addressKey] = countryAbbreviations[short_name] || short_name;
        } else {
          address[addressKey] = value;
        }
      }
    });
  });

  if (!address.city && township) {
    address.city = township;
  }

  return address;
};

